
export class LazyLoad {

    /* INSTANCE */
    private pixels: number;
    private viewport_top: number;
    private viewport_bottom: number;

    constructor() {
        this.pixels = 0;
        this.viewport_top = 0;
        this.viewport_bottom = 0;
    }

    public setPixels(pixels: number) {
        this.pixels = pixels;
    }

    public async lazy(htmlItems: HTMLElement[]): Promise<any> {
        this.viewport_top = 0 - this.pixels;
        this.viewport_bottom = window.innerHeight + this.pixels;
        for (let item of htmlItems) {
            if ((item.getBoundingClientRect().top <= this.viewport_bottom && item.getBoundingClientRect().bottom > this.viewport_top) || (item.getBoundingClientRect().top >= this.viewport_top && item.getBoundingClientRect().bottom < this.viewport_bottom)) {
                return item;
            }
        }
    }

    public isInViewport(el: HTMLElement, el2?: HTMLElement[]): boolean {
        let bounding = el.getBoundingClientRect();
        let bounding2;
        if (el2) {
            let hidden = [];
            for (let item of el2) {
                if (item) {
                    bounding2 = item.getBoundingClientRect();
                    hidden.push(this.isLayerHiddenByLayer(bounding, bounding2));
                }
            }
            if (hidden.includes(true)) return false;
        }
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    private isLayerHiddenByLayer(el: DOMRect, el2: DOMRect): boolean {
        return el.left + el.width > el2.left &&
            el.left < el2.left + el2.width &&
            el.top + el.height > el2.top &&
            el.top < el2.top + el2.height;
    }

}
